"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPinoAdapter = exports.ConsoleAdapter = void 0;
var consoleAdapter_1 = require("./consoleAdapter");
Object.defineProperty(exports, "ConsoleAdapter", { enumerable: true, get: function () { return consoleAdapter_1.ConsoleAdapter; } });
var pinoAdapter_1 = require("./pinoAdapter");
Object.defineProperty(exports, "createPinoAdapter", { enumerable: true, get: function () { return pinoAdapter_1.createPinoAdapter; } });
//# sourceMappingURL=index.js.map